/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useStyletron} from 'baseui'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {ANCHOR, Drawer} from 'baseui/drawer'
import {StyledLink} from 'baseui/link'
import {ListItem, ListItemLabel} from 'baseui/list'
import map from 'lodash/map'
import React from 'react'
import {useFirebase} from 'react-redux-firebase'
import {Link} from 'react-router-dom'
import {navigation} from '../../utils/config'

const HeaderMobileMenu = ({isMobileMenuOpen, toggleMobileMenu}) => {
  const [useCss, theme] = useStyletron()
  const firebase = useFirebase()

  const handleLogout = async () => {
    await firebase.logout()
  }

  const MenuLink = ({item}) => (
    <StyledLink
      $as={Link}
      to={item.url}
      onClick={toggleMobileMenu}
      className={useCss({color: theme.colors.negative400, textDecoration: 'none'})}
    >
      <ListItem
        artwork={() => (
          <Block width={theme.sizing.scale900} display="flex" justifyContent="center">
            <FontAwesomeIcon icon={item.icon} color={theme.colors.primary700} size="2x" />
          </Block>
        )}
      >
        <ListItemLabel>{item.name}</ListItemLabel>
      </ListItem>
    </StyledLink>
  )

  return (
    <Drawer
      onClose={toggleMobileMenu}
      isOpen={isMobileMenuOpen}
      anchor={ANCHOR.top}
      overrides={{
        DrawerContainer: {
          style: {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      }}
    >
      <Block
        overrides={{
          Block: {
            style: {
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
          },
        }}
      >
        <Block
          overrides={{
            Block: {
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                maxWidth: '24rem',
              },
            },
          }}
        >
          <Block
            $as="ul"
            overrides={{
              Block: {
                style: {
                  width: '375px',
                  paddingLeft: 0,
                  paddingRight: 0,
                },
              },
            }}
          >
            {map(navigation.small.auth, item => (
              <MenuLink item={item} key={item.url} />
            ))}
            <Button
              $as={StyledLink}
              onClick={handleLogout}
              overrides={{
                BaseButton: {
                  style: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    width: '100%',
                  },
                },
              }}
            >
              <ListItem
                artwork={() => (
                  <Block width={theme.sizing.scale900} display="flex" justifyContent="center">
                    <FontAwesomeIcon
                      icon="sign-out-alt"
                      color={theme.colors.primary700}
                      size="2x"
                    />
                  </Block>
                )}
              >
                <ListItemLabel>Logout</ListItemLabel>
              </ListItem>
            </Button>
          </Block>
        </Block>
      </Block>
    </Drawer>
  )
}

export default HeaderMobileMenu
